import React from 'react';
import {
  CardElement,
  useStripe,
  useElements
} from '@stripe/react-stripe-js';

const createOptions = {
  hidePostalCode: true,
  style: {
    base: {
      color: '#32325d',
      fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      '::placeholder': {
        color: '#999999',
      },
    },
    invalid: {
      color: '#a94442',
      iconColor: '#a94442',
    },
  },
};

const StripeFields = ({ handleSubmit, submitId, children }) => {
  const stripe = useStripe();
  const elements = useElements();

  const onSubmit = async (event) => {
    event.preventDefault();
    
    if (!stripe || !elements) {
      return;
    }

    const cardElement = elements.getElement(CardElement);
    if (!cardElement) {
      return;
    }

    if (typeof handleSubmit === 'function') {
      handleSubmit(stripe, cardElement);
    }
  };

  return (
    <form onSubmit={onSubmit}>
      <CardElement options={createOptions} />
      <input id={submitId} type="submit" style={{ display: 'none' }} />
      {children}
    </form>
  );
};

export default StripeFields;
